import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
    issueCardPreInqInfo,
    initialState,
} from 'app/core/models/slice/crd/issueCardPreInqInfo'
import { isObject, isArray } from 'lodash'

const slice = createSlice({
    name: 'issueCardPreInqInfo',
    initialState,
    reducers: {
        clearIssueCardPreInqInfo: (state) => {
            Object.keys(initialState).map((key1) => {
                if (isObject(state[key1])) {
                    state[key1] = {}
                } else if (isArray(state[key1])) {
                    state[key1] = []
                } else {
                    state[key1] = ''
                }
            })
        },
        setIssueCardPreInqInfoArr: (state, action: PayloadAction<any>) => {
            action.payload.map((joinArr) => {
                state[joinArr.key] = joinArr.value
            })
        },
        setIssueCardPreInqInfoObArr: (state, action: PayloadAction<any>) => {
            Object.keys(action.payload).map((key) => {
                Object.keys(initialState).map((key1) => {
                    if (
                        key1 === key &&
                        action.payload[key] !== '' &&
                        action.payload[key] !== undefined &&
                        action.payload[key] !== null
                    ) {
                        state[key] = action.payload[key]
                    }
                })
            })
        },
    },
})

export const {
    clearIssueCardPreInqInfo,
    setIssueCardPreInqInfoArr,
    setIssueCardPreInqInfoObArr,
} = slice.actions

export default slice.reducer
